(function () {
  'use strict';

  var DEFAULT_HEADLINE = 'Add 3+ for free shipping';
  var DEFAULT_BONUS = '+ 5% off at 4 · 10% off at 5';
  var POLL_MS = 4000;
  var lastQty = null;
  var pollTimer = null;

  function ensureBar() {
    var offer = document.querySelector('.auk-rotation-offer');
    if (!offer || offer.dataset.cartProgressInited) return;
    offer.dataset.cartProgressInited = '1';

    var headline = offer.querySelector('.auk-rotation-headline');
    if (headline) {
      var bar = document.createElement('div');
      bar.className = 'auk-rotation-bar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="auk-rotation-bar-fill"></div>';
      headline.parentNode.insertBefore(bar, headline);
    }

    if (!document.getElementById('auk-rotation-bar-styles')) {
      var style = document.createElement('style');
      style.id = 'auk-rotation-bar-styles';
      style.textContent =
        '.auk-rotation-bar{height:3px;background:rgba(0,0,0,0.08);border-radius:2px;margin:0 auto 14px;max-width:80%;overflow:hidden;}' +
        '.auk-rotation-bar-fill{height:100%;width:0%;background:var(--color-foreground,#1f2747);transition:width 450ms ease-out;}' +
        '.auk-rotation-headline.is-unlocked{color:var(--color-foreground,#1f2747);}';
      document.head.appendChild(style);
    }
  }

  function messageFor(qty) {
    if (qty <= 0) {
      return { headline: DEFAULT_HEADLINE, bonus: DEFAULT_BONUS, pct: 0, unlocked: false };
    }
    if (qty === 1) {
      return { headline: '1 in cart — add 2 more for free shipping', bonus: DEFAULT_BONUS, pct: 33, unlocked: false };
    }
    if (qty === 2) {
      return { headline: '2 in cart — add 1 more for free shipping', bonus: DEFAULT_BONUS, pct: 66, unlocked: false };
    }
    if (qty === 3) {
      return { headline: 'Free shipping unlocked', bonus: 'Add 1 more for 5% off · 2 more for 10% off', pct: 100, unlocked: true };
    }
    if (qty === 4) {
      return { headline: '5% off unlocked', bonus: 'Add 1 more for 10% off', pct: 100, unlocked: true };
    }
    return { headline: '10% off unlocked', bonus: 'Maximum rotation', pct: 100, unlocked: true };
  }

  function render(qty) {
    if (qty === lastQty) return;
    lastQty = qty;
    ensureBar();
    var headline = document.querySelector('.auk-rotation-headline');
    var bonus = document.querySelector('.auk-rotation-bonus');
    var fill = document.querySelector('.auk-rotation-bar-fill');
    if (!headline) return;

    var msg = messageFor(qty);
    headline.textContent = msg.headline;
    if (bonus) bonus.textContent = msg.bonus;
    if (fill) fill.style.width = msg.pct + '%';
    headline.classList.toggle('is-unlocked', msg.unlocked);
  }

  function fetchCart() {
    if (!document.querySelector('.auk-rotation-offer')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) render(data.item_count || 0); })
      .catch(function () { /* fail silent */ });
  }

  function startPoll() {
    if (pollTimer) return;
    pollTimer = setInterval(fetchCart, POLL_MS);
  }
  function stopPoll() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCart);
  } else {
    fetchCart();
  }

  ['cart:updated', 'cart:refresh', 'cart:added', 'cart:change', 'shopify:cart:updated', 'on:cart:update'].forEach(function (evt) {
    document.addEventListener(evt, fetchCart);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopPoll(); }
    else { fetchCart(); startPoll(); }
  });

  startPoll();
})();
